import CopyClipboard from '@/components/copy-clipboard/copy-clipboard';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { consoleAPI } from '@/providers/apis/console/console';
import { PARTNERS_TYPE_OBJECT_ARRAY_WISE } from '@/utils/constants';
import { isEmptyValue } from '@/utils/utils';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
  name: 'partner-profile-details',
  components: {
    'copy-clipboard': CopyClipboard,
  },
})

export default class PartnerProfileDetails extends Vue {

  // ------------------------------------------------------------------
  // Properties

  @Prop({ default: {} })
  private activePartner: any;

  private overallMetrics: any = [];

  private productHead: any = [
    {
      label: 'S.No',
      key: 'index',
    },
    {
      label: 'Name',
      key: 'name',
      sortable: true,
    },
    {
      label: 'Subject',
      key: 'subject',
    },
    {
      label: 'Audience',
      key: 'audience',
    },
  ];

  private productList: any = [
    {
      index: 1,
      name: 'Learning A-z',
      subject: 'Math',
      audience: 'Student',
    },
    {
      index: 2,
      name: 'Raz A-z',
      subject: 'ELA',
      audience: 'Student',
    },
  ];

  private navigatorSecret = {
    clientId: '',
    secretCode: '',
  };

  private partnerDetails: any = {};

  private partnersType: any = PARTNERS_TYPE_OBJECT_ARRAY_WISE;

  private previewImage: string = '';

  private get isEnableSecretCodeButton() {
    let value = true;
    if (!isEmptyValue(this.navigatorSecret) && !isEmptyValue(this.navigatorSecret.secretCode)) {
      value = false;
    }
    return value;
  }

  private get partnerType() {
    const partnersTypes = this.partnersType;
    const activePartner = this.activePartner;
    const partner = activePartner ? activePartner.partner_type : 'content_developers';
    return partnersTypes[partner];
  }

  private get partnerDescription() {
    const additionalInfo = this.activePartner.additional_info || {};
    return additionalInfo.notes || '';
  }

  private imageList: any = [];

  private videosList: any = [];


  // ---------------------------------------------------------------
  // Hooks

  private mounted(): void {
    this.overallMetrics = this.parseMetricsData();
    this.loadPartnerContent();
    this.getCreatedOAuth();
  }

  // --------------------------------------------------------------
  // Actions

  private onGoBack() {
    this.$emit('onSwitch', 'curriculum-provider');
  }

  private onPreview(logo: string) {
    this.previewImage = logo;
    this.$bvModal.show('preview-box');
  }

  // ------------------------------------------------------------
  // Methods

  private loadPartnerContent() {
    const activePartner = this.activePartner;
    const images = activePartner.images || [];
    const videos = activePartner.videos || [];
    this.imageList = images;
    this.videosList = videos;
  }

  private parseMetricsData() {
    const activePartner = this.activePartner;
    const timespent = moment(activePartner.total_timespent);
    return [
      {
        name: 'Activities Conducted',
        count: activePartner.total_activities_conducted,
        icon: 'local_activity',
      },
      {
        name: 'Competencies Gained',
        count: activePartner.total_competencies_gained,
        icon: 'emoji_events',
      },
      {
        name: 'Total Class',
        count: activePartner.total_classes,
        icon: 'class',
      },
      {
        name: 'Total Timespent',
        count: `${timespent.format('hh')} Hours ${timespent.format('mm')} Minutes `,
        isTimespent: true,
        icon: 'schedule',
      },
    ];
  }

  private onNewSecret() {
    if (!isEmptyValue(this.navigatorSecret.secretCode)) {
      return;
    }
    if (!isEmptyValue(this.activePartner.tenant_id)) {
      const payload = {
        tenant_id: this.activePartner.tenant_id,
        partner_id: this.activePartner.partner_id,
      };
      adminUtilsAPI.fetchOAthClientSecret(payload).then((data: any) => {
        const code: any = {
          client_id: data.client_id,
          client_secret: data.client_secret,
        };
        this.navigatorSecret.clientId = data.client_id;
        this.navigatorSecret.secretCode = data.client_secret;
      });
    }
  }

  private getCreatedOAuth() {
    const params = {
      tenant_id: this.activePartner.tenant_id,
      partner_id: this.activePartner.partner_id,
    };
    if (!isEmptyValue(this.activePartner.tenant_id)) {
      adminUtilsAPI.fetchOAuthConfig(params).then((dataResp: any) => {
        if (dataResp && dataResp.length > 0) {
          const data = dataResp[0];
          this.navigatorSecret.clientId = data.client_id;
          this.navigatorSecret.secretCode = data.client_secret;
        }
      });
    }
  }
}
